// Every landing page (services, city routes, airports), for routes, the footer, the sitemap check
// and related links. Pages without a real price are already filtered out by each module.
import { SERVICE_PAGES } from './services';
import { CITY_PAGES } from './cityRoutes';
import { AIRPORT_ROUTES } from '../airports';

export { SERVICE_PAGES, CITY_PAGES, AIRPORT_ROUTES };

export const LANDING_PAGES = [...SERVICE_PAGES, ...CITY_PAGES, ...AIRPORT_ROUTES];

export const LANDING_BY_PATH = Object.fromEntries(LANDING_PAGES.map((p) => [p.path, p]));
